<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12" v-if="lAction === 'view'">
        <v-card class="ma-2" v-if="lAction === 'view'">
          <v-card-title class="title grey lighten-4 primary--text pa-2">
            <div>Open Bookings ({{bookingList.length}})</div>
          </v-card-title>
          <v-card-text class="pa-0">
            <template>
              <v-data-table
              :headers="bookingListHead"
              :items="bookingList"
              disable-pagination
              hide-default-footer
              :mobile-breakpoint="0"
              >
              <template slot="item" slot-scope="props">
                <tr @click="prepareEditBooking(props.item)">
                  <td>{{ props.item.booking_no }}</td>
                  <td>{{ handy.formatDate(props.item.booking_dt) }}</td>
                  <td>{{ props.item.cust_name }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.contact_phone }}</td>
                  <td>{{ props.item.service_name}}</td>
                  <td>{{ props.item.bill_amount }}</td>
                  <td>{{ props.item.status }}</td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-col>
</v-row>

<!-- create/update bookings -->
<v-container grid-list-md v-if="lAction ==='create' || lAction === 'update'" fluid full-height>
  <v-flex xs12 sm9 mx-auto>
    <v-form ref="bForm" @submit.prevent="saveChanges(lAction)">
      <v-card flat>
        <v-card-title class="title pa-2">
          {{ handy.startWithUpper(lAction) }} Booking
        </v-card-title>
        <v-card-text class="pa-2">
          <v-layout row wrap>
            <v-flex xs6>
              <v-select
              v-model="lBooking.booking_mode"
              :items="['PHONE', 'EMAIL', 'STORE']"
              label="Booking Mode"
              hide-details
              :rules="[rules.required]"
              ></v-select>
            </v-flex>
            <v-flex xs6 v-if="$vuetify.breakpoint.smAndUp"></v-flex>
            <v-flex xs12 sm6>
              <v-text-field
              v-model="lBooking.contact_phone"
              label= "Customer Phone"
              hide-details
              maxlength="15"
              type="number"
              @change="searchCustomerDet()"
              :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
              label="Customer Name"
              v-model="lBooking.cust_name"
              :rules="[rules.required]"
              hide-details
              maxlength="50"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 xs6>
              <v-text-field
              label="Address"
              v-model="lBooking.address"
              hide-details
              maxlength="150"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field
              label="City"
              v-model="lBooking.city"
              hide-details
              maxlength="25"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 sm3>
              <v-text-field
              label="PIN"
              v-model="lBooking.pin_code"
              hide-details
              maxlength="10"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="pt-5">
              <v-card>
                <v-card-title class="pa-2 subtitle-1 primary--text grey lighten-4">
                  <div>Service Requested</div>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="prepareCreateNewService"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="serviceHeader"
                  :items="lBooking.details"
                  hide-default-footer
                  disable-pagination
                  :mobile-breakpoint="0">
                  <template slot="item" slot-scope="props">
                    <tr @click="prepareEditService(lBooking.details)">
                      <td>{{ props.item.service_name }}</td>
                      <td>{{ props.item.uom }}</td>
                      <td>{{ props.item.price }}</td>
                      <td>{{ props.item.qty }}</td>
                      <td>{{ props.item.bill_amount }}</td>
                      <td>{{ props.item.tax }}</td>
                      <td>{{ props.item.total }}</td>
                      <td>{{ props.item.status }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <v-flex xs12 class="black--text pa-0">
                  <v-divider></v-divider>
                  <v-layout wrap>
                    <v-flex sm8 class="text-right pr-5">
                      <span>Total</span>
                    </v-flex>
                    <v-flex sm3 class="pl-5">
                      <span>{{handy.formatCur(lBooking.total_bill_amount) + ' + 0 tax'}}</span>
                    </v-flex>
                    <v-flex sm1>
                      <span>Unpaid</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="lAction === 'update'" @click="saveChanges('delete')">Delete</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click.stop="cancelChanges">Cancel</v-btn>
        <v-btn type="submit" color="accent">save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-flex>
</v-container>

<!-- create new services -->
<v-dialog v-model="showNewService" scrollable persistent max-width="600px">
  <v-container grid-list-md class="pa-0" fluid full-height>
    <v-form ref="lForm" @submit.prevent="saveJobDetails()">
      <v-card>
        <v-card-title class="subtitle-1 py-2 primary--text grey lighten-4">
          New Service
        </v-card-title>
        <v-card-text class="pa-3">
          <v-flex xs12>
            <v-combobox
            v-model="lJob.service_pair"
            label="Service Name"
            :items="masterServiceList"
            item-text="service_name"
            item-value="service_id"
            :rules="[rules.required]"
            persistent-hint
            :disabled="lAction === 'update'"
            @change="loadPriceChart(lJob.service_pair.service_id)"
            ></v-combobox>
          </v-flex>
          <v-flex xs12>
            <v-data-table
            ref="jobTable"
            :items="lJob.detail"
            hide-default-footer
            :options.sync="options"
            row wrap>
            <template slot="item" slot-scope="props">
              <v-flex xs12 class="accent lighten-5">
                <v-card flat class="pb-2">
                  <v-card-text class="pa-2 accent lighten-5">
                    <v-layout wrap>
                      <v-flex xs5>
                        <v-combobox
                        v-model="props.item.uom"
                        :items="priceChartList"
                        item-text="uom"
                        item-value="uom"
                        label="Job"
                        :rules="[rules.required]"
                        @change="loadPriceBasedOnUom(props.item)"
                        hide-details
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                        v-model="props.item.price"
                        label="Price"
                        hide-details
                        type="Number"
                        readonly
                        disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                        v-model="props.item.qty"
                        label="Quantity"
                        hide-details
                        maxlength="11"
                        type="Number"
                        :rules="[rules.required]"
                        @input="calculateBillAmount(props.item)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-text-field
                        v-model="props.item.bill_amount"
                        label="Amount"
                        hide-details
                        type="Number"
                        readonly
                        disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs1>
                        <v-btn v-if="lJob.detail.length > 1" small icon class="ma-0" @click="removeJobs(props.item)"><v-icon small>mdi-minus-circle-outline</v-icon></v-btn>
                        <v-btn v-else small icon class="ma-0" @click=""></v-btn> <!-- dummy button -->
                        <v-btn v-if="props.index === lJob.detail.length - 1" small icon class="ma-0" @click="addJobs"><v-icon small>mdi-plus-circle-outline</v-icon></v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12>
          <v-flex xs12 class="py-2 px-0 title">
            Total Amount: <span class="accent--text">{{ handy.formatCur(lJob.bill_amount ? lJob.bill_amount : 0) + ' (' + (lJob.bill_amount ? lJob.bill_amount : 0) + ' + 0 Tax)' }}</span>
          </v-flex>
          <v-card flat>
            <v-card-title class=" pa-0 subtitle-1 primary--text">
              Status
            </v-card-title>
            <v-card-text class="px-0 pb-2">
              <v-layout wrap>
                <v-flex xs6>
                  <v-select
                  v-model="lJob.status"
                  label="Booking Status"
                  :items="['Booked', 'Assigned', 'Completed', 'Cancelled']"
                  hide-details
                  @input="$forceUpdate()"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model="lJob.priority"
                  label="Priority"
                  :items="['Normal', 'Low', 'High']"
                  hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                  v-model="lJob.assigned_to"
                  label="Assigned To"
                  :items="assignList"
                  item-text="emp_name_with_id"
                  item-value="emp_id"
                  hide-details
                  ></v-combobox>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="planVisitDt"
                  persistent v-model="planVisitDt"
                  max-width="290px"
                  :return-value.sync="lJob.plan_visit_dt"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Planned Start Date"
                    v-model="lJob.plan_visit_dt"
                    append-icon="mdi-calendar-today"
                    readonly clearable
                    hide-details
                    required
                    v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="lJob.plan_visit_dt" scrollable
                  first-day-of-week="1"
                  >
                  <v-spacer></v-spacer>
                  <v-btn text @click="planVisitDt = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.planVisitDt.save(lJob.plan_visit_dt)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-dialog
              ref="dlgStartTime"
              persistent
              v-model="dlgStartTime"
              max-width="290px"
              :return-value.sync="lJob.startTime"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                v-on="on"
                slot="activator"
                label="Planned Start Time"
                v-model="lJob.startTime"
                append-icon="mdi-clock"
                clearable
                hide-details
                readonly
                ></v-text-field>
              </template>
              <v-time-picker v-model="lJob.startTime">
                <v-spacer></v-spacer>
                <v-btn text @click="dlgStartTime = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgStartTime.save(lJob.startTime)">OK</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="planEndDt"
            persistent v-model="planEndDt"
            max-width="290px"
            :return-value.sync="lJob.plan_end_dt"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="Planned End Date"
              v-model="lJob.plan_end_dt"
              append-icon="mdi-calendar-today"
              readonly clearable
              hide-details
              required
              v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="lJob.plan_end_dt" scrollable
            first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn text @click="planEndDt = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.planEndDt.save(lJob.plan_end_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs6>
        <v-dialog
        ref="dlgEndTime"
        persistent
        v-model="dlgEndTime"
        max-width="290px"
        :return-value.sync="lJob.endTime"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
          v-on="on"
          slot="activator"
          label="Planned end Time"
          v-model="lJob.endTime"
          append-icon="mdi-clock"
          clearable
          hide-details
          readonly
          ></v-text-field>
        </template>
        <v-time-picker v-model="lJob.endTime">
          <v-spacer></v-spacer>
          <v-btn text @click="dlgEndTime = false">Cancel</v-btn>
          <v-btn text color="accent" @click="$refs.dlgEndTime.save(lJob.endTime)">OK</v-btn>
        </v-time-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs12 v-if="lJob.status === 'Completed'">
      <v-layout wrap>
        <v-flex xs6>
          <v-dialog ref="actEndtDt"
          persistent v-model="actEndtDt"
          max-width="290px"
          :return-value.sync="lJob.act_end_dt"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
            slot="activator" label="Actual End Date"
            v-model="lJob.act_end_dt"
            append-icon="mdi-calendar-today"
            readonly clearable
            hide-details
            required
            v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="lJob.act_end_dt" scrollable
          first-day-of-week="1"
          >
          <v-spacer></v-spacer>
          <v-btn text @click="actEndtDt = false">Cancel</v-btn>
          <v-btn text color="accent" @click="$refs.actEndtDt.save(lJob.act_end_dt)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs6>
      <v-dialog
      ref="actEndTime"
      persistent
      v-model="actEndTime"
      max-width="290px"
      :return-value.sync="lJob.actEndTime"
      >
      <template v-slot:activator="{ on }">
        <v-text-field
        v-on="on"
        slot="activator"
        label="Actual End Time"
        v-model="lJob.actEndTime"
        append-icon="mdi-clock"
        clearable
        hide-details
        readonly
        ></v-text-field>
      </template>
      <v-time-picker v-model="lJob.actEndTime">
        <v-spacer></v-spacer>
        <v-btn text @click="actEndTime = false">Cancel</v-btn>
        <v-btn text color="accent" @click="$refs.actEndTime.save(lJob.actEndTime)">OK</v-btn>
      </v-time-picker>
    </v-dialog>
  </v-flex>
</v-layout>
</v-flex>
</v-layout>
</v-card-text>
<v-card-actions class="pt-3">
  <v-btn v-if="lSAction === 'update'" @click="deleteService()">delete</v-btn>
  <v-spacer></v-spacer>
  <v-btn @click.stop="showNewService = false">Cancel</v-btn>
  <v-btn color="accent" type="submit">Save</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-card-text>
</v-card>
</v-form>
</v-container>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // common
      handy: handy,
      config: config,
      rules: handy.rules,
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      lAction: '',
      lSAction: '',
      // booking
      lBooking: [],
      commList: [],
      blockList: [],
      unitList: [],
      serviceHeader: [
        { text: 'Service Name', value: 'service_name' },
        { text: 'Jobs', value: 'uom' },
        { text: 'Price', value: 'price' },
        { text: 'Quantity', value: 'qty' },
        { text: 'Amount', value: 'bill_amount' },
        { text: 'Tax', value: 'tax' },
        { text: 'Total', value: 'total' },
        { text: 'Status', value: 'status' }
      ],
      lJob: [],
      showNewService: false,
      priceChartList: [],
      planVisitDt: false,
      planEndDt: false,
      dlgStartTime: false,
      dlgEndTime: false,
      actEndtDt: false,
      actEndTime: false,
      options: {},
      masterServiceList: [],
      assignList: [],
      bookingList: [],
      bookingListHead: [
        { text: 'Booking No.', value: 'booking_no', width: '120px' },
        { text: 'Booking Date', value: 'booking_dt', width: '120px' },
        { text: 'Customer Name', value: 'cust_name' },
        { text: 'Address', value: 'address' },
        { text: 'Contact Phone', value: 'contact_phone' },
        { text: 'Services', value: 'service_name' },
        { text: 'Bill Amount', value: 'bill_amount' },
        { text: 'Booking Status', value: 'status' }
      ]
    }
  },
  created () {
    this.lAction = 'view'
  },
  mounted () {
    this.loadOpenBookingList()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyBooking () {
      var EmptyBooking = {
        booking_mode: 'PHONE',
        contact_phone: '',
        cust_name: '',
        comm_pair: [],
        unit_pair: [],
        block_pair: [],
        address: '',
        city: '',
        assigned_to: null,
        details: []
      }
      return EmptyBooking
    },
    prepareCreate () {
      this.lBooking = this.getEmptyBooking()
      this.lAction = 'create'
    },
    searchCustomerDet () {
      var qry = {
        params: {
          contact_phone: this.lBooking.contact_phone
        }
      }
      this.axios.get(config.API_URL + '/getCustDetailsByPhone/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.msg('Customer record not found', 2)
          this.lBooking.cust_id = ''
          this.lBooking.cust_name = ''
          this.lBooking.address = ''
          this.lBooking.city = ''
          this.lBooking.phone = ''
        } else {
          this.lBooking.cust_id = response.data[0].cust_id
          this.lBooking.cust_name = response.data[0].cust_name
          this.lBooking.address = response.data[0].comm_name + ' ' + response.data[0].block_nm + ' ' + response.data[0].unit_no + ' ' + response.data[0].address
          this.lBooking.city = response.data[0].city
          this.lBooking.phone = response.data[0].phone
        }
      })
    },
    loadAssignedListofEmployee() {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeByVendorId/', qry)
      .then(response => {
        this.assignList = response.data
      })
    },
    getEmptyPriceChart () {
      var emptyPriceChart = {
        qty: 0,
        bill_amount: 0
      }
      return emptyPriceChart
    },
    loadMasterServiceList () {
      // available services for this vendor
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSubServicesByVendorId/', qry)
      .then(response => {
        this.masterServiceList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    prepareCreateNewService () {
      this.lJob = {
        service_pair: '',
        uom: '',
        price: '',
        qty: '',
        detail: [],
        status: 'Booked',
        assigned_to: null,
        priority: 'Normal',
        plan_visit_dt: null,
        plan_end_dt: null,
        act_end_dt: null
      }
      this.lJob.detail.push(this.getEmptyPriceChart())
      this.showNewService = true
      this.loadMasterServiceList()
      this.loadAssignedListofEmployee()
    },
    loadPriceChart (curServiceId) {
      var qry = {
        params: {
          service_id: curServiceId
        }
      }
      this.axios.get(config.API_URL + '/getPricechartBasedOnServiceId/', qry)
      .then(response => {
        this.priceChartList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    addJobs () {
      this.lJob.detail.push(this.getEmptyPriceChart())
      this.options = {}
    },
    refreshBillAmount () {
      var tmpAmount = 0
      this.lJob.detail.forEach(det => {
        tmpAmount += Number(det.bill_amount || 0)
      })
      this.lJob.bill_amount = tmpAmount
      this.$forceUpdate()
    },
    removeJobs (curPriceData) {
      var idx = this.lJob.detail.findIndex(rec => rec.uom === curPriceData.uom && rec.price === curPriceData.price)
      this.lJob.detail.splice(idx, 1)
      this.refreshBillAmount()
      this.options = {}
    },
    calculateBillAmount (curPriceData) {
      curPriceData.bill_amount = curPriceData.price * curPriceData.qty
      this.refreshBillAmount()
    },
    loadPriceBasedOnUom (curPriceData) {
      var idx = this.priceChartList.findIndex(rec => rec.uom === curPriceData.uom.uom)
      if (idx > -1) {
        curPriceData.price = this.priceChartList[idx].price
      }
    },
    saveJobDetails () {
      if (this.$refs.lForm.validate()) {
        if (this.lSAction !== 'update' && (this.lJob.detail.length === 0 || !this.lJob.detail[0].uom)) {
          this.msg('Please enter services', 0)
        } else {
          for (var i = 0; i < this.lJob.detail.length; i++) {
            var idx = this.lBooking.details.findIndex(rec => rec.service_id === this.lJob.service_pair.service_id)
            if (idx > -1) {
              if (this.lJob.detail[i].uom.price) {
                this.lJob.detail[i].price = this.lJob.detail[i].uom.price
                this.lJob.detail[i].uom = this.lJob.detail[i].uom.uom
              }
              this.lJob.detail[i].service_id = this.lJob.service_pair.service_id
              this.lJob.detail[i].total = this.lJob.detail[i].bill_amount
              this.lJob.detail[i].service_name = this.masterServiceList.filter(rec => rec.service_id === this.lJob.service_pair.service_id)[0].service_name
              Object.assign(this.lBooking.details[i], this.lJob.detail[i])
            } else {
              this.lJob.detail.forEach(rec => {
                this.lBooking.details.push({
                  price: rec.price,
                  uom: rec.uom.uom,
                  service_id: this.lJob.service_pair.service_id,
                  service_name: this.lJob.service_pair.service_name,
                  qty: rec.qty,
                  bill_amount: rec.bill_amount,
                  status: this.lJob.status,
                  tax: 0,
                  total: rec.bill_amount
                })
              })
            }
            this.lBooking.total_bill_amount = this.lJob.bill_amount
            this.lBooking.priority = this.lJob.priority
            this.lBooking.status = this.lJob.status
            this.lBooking.assigned_to = this.lJob.assigned_to.emp_id
            this.lBooking.plan_visit_dt = this.lJob.plan_visit_dt + ' ' + this.lJob.startTime
            this.lBooking.plan_end_dt = this.lJob.plan_end_dt + ' ' + this.lJob.endTime
            if (this.lBooking.status === 'Completed') {
              this.lBooking.act_end_dt = this.lJob.act_end_dt ? this.lJob.act_end_dt + ' ' + this.lJob.actEndTime : null
            }
            if (!this.lJob.plan_visit_dt) {
              this.msg('please enter plan start date and time', 0)
            } else if (!this.lJob.plan_end_dt) {
              this.msg('please enter plan end date and time', 0)
            } else {
              this.showNewService = false
            }
          }
        }
      }
    },
    saveChanges (action) {
      if (!this.$refs.bForm.validate()) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/on-callbooking/' + action, this.lBooking)
      .then(response => {
        this.loadOpenBookingList()
        this.beingSaved = false
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err, 0)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lBooking = this.getEmptyBooking()
      this.lAction = 'view'
    },
    loadOpenBookingList () {
      this.axios.get(config.API_URL + '/getOpenBookings/')
      .then(response => {
        this.bookingList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareEditBooking (curBooking) {
      this.lBooking = Object.assign({}, curBooking)
      this.lBooking.details = []
      var tmpPrice = this.lBooking.price.split(',')
      var tmpQty = this.lBooking.qty.split(',')
      var tmpServiceName = this.lBooking.service_name.split(',')
      for (var i = 0; i < tmpServiceName.length; i++) {
        var splitString = tmpServiceName[i].split(' (')
        this.lBooking.details.push({
          price: tmpPrice[i],
          service_id: this.lBooking.service_id,
          service_name: splitString[0],
          uom: splitString[1].substring(0, splitString[1].length - 1),
          qty: tmpQty[i],
          bill_amount: tmpPrice[i] * tmpQty[i],
          status: this.lBooking.status,
          tax: 0,
          total: tmpPrice[i] * tmpQty[i]
        })
      }
      this.lBooking.total_bill_amount = curBooking.bill_amount
      this.lJob.plan_visit_dt = handy.formatDBDate(this.lBooking.plan_visit_dt)
      this.lJob.startTime = handy.getLongTime(this.lBooking.plan_visit_dt)
      this.lJob.plan_end_dt = handy.formatDBDate(this.lBooking.plan_end_dt)
      this.lJob.endTime = handy.getLongTime(this.lBooking.plan_end_dt)
      this.loadAssignedListofEmployee()
      this.lAction = 'update'
    },
    prepareEditService (curService) {
      this.lJob = Object.assign({}, curService)
      this.lJob.service_pair = { service_id: this.lJob[0].service_id, service_name: this.lJob[0].service_name }
      this.lJob.detail = []
      this.lJob.bill_amount = 0
      curService.forEach(rec => {
        this.lJob.detail.push({
          price: rec.price,
          qty: rec.qty,
          uom: rec.uom,
          bill_amount: rec.bill_amount
        })
        this.lJob.bill_amount += rec.bill_amount
      })
      this.lJob.priority = this.lBooking.priority
      this.lJob.status = this.lBooking.status
      this.lJob.assigned_to = {emp_id: this.lBooking.emp_id, emp_name_with_id: this.lBooking.emp_name_with_id}
      this.lJob.plan_visit_dt = handy.formatDBDate(this.lBooking.plan_visit_dt)
      this.lJob.startTime = handy.getLongTime(this.lBooking.plan_visit_dt)
      this.lJob.plan_end_dt = handy.formatDBDate(this.lBooking.plan_end_dt)
      this.lJob.endTime = handy.getLongTime(this.lBooking.plan_end_dt)
      this.loadPriceChart(this.lJob[0].service_id)
      this.loadMasterServiceList()
      this.showNewService = true
      this.lSAction = 'update'
    },
    deleteService () {
      if (!confirm('Sure, you want to delete the bookings with service name "' + this.lJob.service_pair.service_name + '"?')) {
        // delete
        return
      }
      this.lBooking.details = []
      this.lJob.detail = []
      if (this.lSAction !== 'update' && this.lBooking.details.length === 0) {
        this.msg('Please enter services', 0)
      }
      this.showNewService = false
    }
  }
}
</script>
